module.exports = __webpack_public_path__ + "img/Accept-order.af0a6357.png";